import React  from "react";
import { AnimationFileLoader } from '../../../utilis/animation-loader'; // Adjust the path
import {NavLink } from "react-router-dom";

//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />

function ItemDetails() {
    AnimationFileLoader();

  return (
    <>
 
    {/* Author */}
    <div className="author-area">
        <div className="author-cover" data-bg-img="/img/bg/author-cover.png"></div>
    </div>
    {/* End Author */}

    {/* Item Details */}
    <section className="pt-120 pb-120">
        <div className="container">
            <div className="row justify-content-between">
                <div className="col-lg-6 order-1 order-lg-0">
                    {/* Item Details Content */}
                    <div className="item-details ov-hidden">
                        <h2 className="product-title">Animal Girl Painting</h2>

                        {/* Favorite */}
                        <div className="favorites">
                            <h6 className="available">Available 12</h6>
                            <div className="love-react-wrap d-flex align-items-center">
                                <div className="love-react style--two"></div>
                                <div className="love-count">13.6k</div>
                            </div>
                        </div>
                        {/* End Favorite */}

                        <p>Anefty, NavLink one-of-NavLink-kind trading card is an NFTs – you can't just replace it with any
                            others card. If you these different from fungible items, which are often the same as
                            each othes you have something. differ from fungible item
                            <NavLink to="#" className="read-more c1">read more...</NavLink>
                        </p>

                        <div className="row pt-1">
                            <div className="col-sm-6">
                                {/* Price */}
                                <div className="price mb-4 mb-sm-0">
                                    <h6>Item Price</h6>
                                    <h3>1.69 ETH</h3>
                                </div>
                                {/* End Price */}
                            </div>
                            <div className="col-sm-6">
                                {/* Countdown */}
                                <div className="countdown-wrapper">
                                    <h6>Countdown</h6>

                                    <ul className="countdown">
                                        <li>
                                            <h3 className="hours">00</h3>
                                        </li>
                                        <li className="ms-1 me-1"> : </li>
                                        <li>
                                            <h3 className="minutes">00</h3>
                                        </li>
                                        <li className="ms-1 me-1"> : </li>
                                        <li>
                                            <h3 className="seconds">00</h3>
                                        </li>
                                    </ul>
                                </div>
                                {/* End Countdown */}
                            </div>
                        </div>

                        <div className="row mb-4 mt-30 pt-2">
                            <div className="col-sm-6">
                                {/* Item Quantity */}
                                <div className="item-quantity mb-4 mb-sm-0">
                                    <h6>Item Quantity</h6>

                                    {/* Quantity */}
                                    <div className="quantity d-flex align-items-center justify-content-between">
                                        <h6 className="mb-0">Quantity of</h6>
                                        <div>
                                            <input type="text" className="input-text qty text"  />
                                            <span className="plus">
                                                <i className="fa fa-caret-up"></i>
                                            </span>
                                            <span className="minus">
                                                <i className="fa fa-caret-down"></i>
                                            </span>
                                        </div>
                                    </div>
                                    {/* End Quantity */}
                                </div>
                                {/* End Item Quantity */}
                            </div>
                            <div className="col-sm-6">
                                {/* Item Price */}
                                <div className="item-price">
                                    <h6>Item Price</h6>

                                    <div className="item-price-inner align-items-center d-flex justify-content-between">
                                        <h6 className="mb-0">Amount </h6>
                                        <h6 className="mb-0">1.69 ETH</h6>
                                    </div>
                                </div>
                                {/* End Item Price */}
                            </div>
                        </div>

                        <div className="button-group style--two">
                            <NavLink to="pages/item-details" className="btn btn-border btn-sm"><img
                                    src="/img/icons/btn-buy-now-icon.svg" alt="" className="svg"/> Buy Now</NavLink>
                            <NavLink to="pages/item-details" className="btn btn-sm"><img src="/img/icons/judge-icon.svg"
                                    alt="" className="svg"/> Place Bid</NavLink>
                        </div>

                        <div className="row mb-4 mt-40 pt-1">
                            <div className="col-sm-6">
                                {/* Creator */}
                                <NavLink to="profile.html" className="hz-profile creator media mb-4 mb-sm-0">
                                    <div className="avatar">
                                        <img src="/img/media/creator-avatar.png" alt="" />
                                    </div>
                                    <div className="content media-body">
                                        <h6>Creator</h6>
                                        <h5>Anehty_Yacht</h5>
                                    </div>
                                </NavLink>
                                {/* End Creator */}
                            </div>
                            <div className="col-sm-6">
                                {/* Owner */}
                                <NavLink to="profile.html" className="hz-profile owner media">
                                    <div className="avatar">
                                        <img src="/img/media/owner-avatar.png" alt="" />
                                    </div>
                                    <div className="content media-body">
                                        <h6>Owner</h6>
                                        <h5>Cyber_Kongz</h5>
                                    </div>
                                </NavLink>
                                {/* End Owner */}
                            </div>
                        </div>

                        {/* Tab Buttons */}
                        <ul className="nav tab-buttons style--two">
                            <li>
                                <button className="active" data-bs-toggle="tab" data-bs-target="#info">Info</button>
                            </li>
                            <li>
                                <button data-bs-toggle="tab" data-bs-target="#bids">Bids</button>
                            </li>
                        </ul>
                        {/* End Tab Buttons */}

                        <div className="tab-content">
                            <div className="tab-pane fade show active" id="info">
                                {/* Info List */}
                                <ul className="info-list">
                                    <li>
                                        <h6>NFTs ID</h6>
                                        <h3>690563</h3>
                                    </li>
                                    <li>
                                        <h6>Mint Transactions</h6>
                                        <h3>69b9ebde0178k7O7&export</h3>
                                    </li>
                                    <li>
                                        <h6>Contact Address</h6>
                                        <h3>kɒngtækt əˈdrɛs</h3>
                                    </li>
                                </ul>
                                {/* End Info List */}
                            </div>
                            <div className="tab-pane fade" id="bids">
                                <p>No active bids yet. Be the first to make NavLink bid!</p>
                            </div>
                        </div>
                    </div>
                    {/* End Item Details Content */}
                </div>
                <div className="col-xl-5 col-lg-6 order-0 order-lg-1">
                    {/* Item Details IMG */}
                    <div className="item-details-img mb-5 mb-lg-0">
                        <img src="/img/media/item-details.png" alt=""/>
                    </div>
                    {/* End Item Details IMG */}
                </div>
            </div>
        </div>
    </section>
    {/* End Item Details */}

    </> 

  );
}

export default ItemDetails;
